/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Tooltip from './tooltip';
import Widget from '../../widget';
import { renderTooltipJsx } from '../../../../helpers/Tooltip';
import Chart from '../../../Modules/pme/screens/dashboard/widgets/sdgs/chart';

const data = [
  { color: '#FF9C6E', percent: 0 },
  { color: '#2E90FA', percent: 0 },
]

export default function RepaymentOverview({ title = 'Overview' }) {
  const { t } = useTranslation();

  const _renderTooltip = ({ mouseX, mouseY, item }) => {
    return (
      <Tooltip
        mouseY={mouseY}
        mouseX={mouseX}
        children={renderTooltipJsx({
          title: t('Overview'),
          items: [
            {
              label: t('Total'),
              value: '$0',
              isTotal: true,
            },
            {
              color: '#2E90FA',
              label: t('Amount payed'),
              value: '$0',
            },
            {
              color: '#FF9C6E',
              label: t('Amount owed'),
              value: '$0',
            }
          ]
        })}
      />
    )
  }

  return (
    <Widget
      className="with-border-header"
      title={t(title)}
    >
      <div className='flex flex-1 flex-column justify-content-center'>
        <div className='flex justify-content-center'>
          <Style>
            <Chart
              changeOpacityOnHover={false}
              data={data}
              t={t}
              withBody={false}
              isEmpty
              renderTooltip={_renderTooltip}
              className="no-max-width small-chart"
            />
          </Style>
        </div>
      </div>
    </Widget>
  )
}
